const classes = Object.freeze({
    root: 'll-card ll-card-button',
});

export {
    classes,
};